import React from 'react'
import PageFilters from '../PageFilters'
import { useParams } from 'react-router-dom'
import useQuery from '../useQuery'

import CustomerAge from './CustomerAge'
import './CustomerDemographic.css'

const Audience = () => {
    const { id: eventId } = useParams()
    const { startDate = null, endDate = null } = useQuery()

    return (
        <div>
            <PageFilters startDate={startDate} endDate={endDate} />
            <div className="wrapper wrapper-content">
                <div className="animated fadeIn">
                    <div style={{ marginTop: -15, paddingTop: 0 }}>
                        <div className="row">
                            <div className="col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1 col-sm-12">
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-7">
                                        <CustomerAge
                                            eventId={eventId}
                                            startDate={startDate}
                                            endDate={endDate}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Audience
